var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLottery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_52_1",
    "data-name": "Component 52 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.99,
    viewBox: "0 0 16 16.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_609",
    "data-name": "Ellipse 609",
    fill: "currentColor",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(10 4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4702",
    "data-name": "Path 4702",
    fill: "currentColor",
    d: "M5.625,7.471A1.454,1.454,0,0,1,7.031,5.978a1.417,1.417,0,0,1,1.326,1H11.25v-1h2.672A7.156,7.156,0,0,0,7.067,0,1.456,1.456,0,0,1,8.438,1.5,1.454,1.454,0,0,1,7.031,2.991,1.454,1.454,0,0,1,5.625,1.5,1.456,1.456,0,0,1,6.995,0,7.257,7.257,0,0,0,0,7.471,7.619,7.619,0,0,0,2.767,13.41l3.14-5.043A1.546,1.546,0,0,1,5.625,7.471Zm4.219-4.48A1.454,1.454,0,0,1,11.25,4.485a1.409,1.409,0,1,1-2.812,0A1.454,1.454,0,0,1,9.844,2.991Zm-7.784-.8a1.348,1.348,0,0,1,1.989,0,1.558,1.558,0,0,1,0,2.112,1.348,1.348,0,0,1-1.989,0A1.558,1.558,0,0,1,2.059,2.192ZM3.281,8.964A1.454,1.454,0,0,1,1.875,7.471,1.454,1.454,0,0,1,3.281,5.978,1.454,1.454,0,0,1,4.688,7.471,1.454,1.454,0,0,1,3.281,8.964Z",
    transform: "translate(0 -0.005)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4703",
    "data-name": "Path 4703",
    fill: "currentColor",
    d: "M266.737,240.991h-2.672v-1h-2.893a1.509,1.509,0,0,1-.2.4l3.139,5.041A7.524,7.524,0,0,0,266.737,240.991Z",
    transform: "translate(-252.815 -232.031)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    fill: "currentColor",
    d: "M116.679,268.625l-3.139,5.041a6.691,6.691,0,0,0,3.447.977,1.409,1.409,0,1,1,.072,0,6.693,6.693,0,0,0,3.446-.979l-3.138-5.039a1.322,1.322,0,0,1-.687,0Z",
    transform: "translate(-109.992 -259.711)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4705",
    "data-name": "Path 4705",
    fill: "currentColor",
    d: "M273.347,406.5H270v1h5.091l-2.234-3.587a7.061,7.061,0,0,1-.781.55Z",
    transform: "translate(-261.563 -390.502)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4706",
    "data-name": "Path 4706",
    fill: "currentColor",
    d: "M17.1,407.55h5.091v-1H18.844l1.27-2.039a6.953,6.953,0,0,1-.781-.55Z",
    transform: "translate(-16.566 -390.56)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4707",
    "data-name": "Path 4707",
    fill: "currentColor",
    d: "M390,209.995v1h3.813v-1Z",
    transform: "translate(-377.813 -203.027)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLottery);
export default __webpack_public_path__ + "static/media/lottery.20e7185c.svg";
export { ForwardRef as ReactComponent };